// extracted by mini-css-extract-plugin
module.exports = {"modalError":"styles_modalError__8er5x"};